import React from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Moment } from 'moment';
import TimeUtils from '../../../utils/TimeUtils';
import { useLanguage } from '../../../common/GeneralUtils';
import { AccountData } from '../../../api';

type HoursBordersHeaderProps = {
  account: AccountData;
};

export const HoursBordersHeader = ({ account }: HoursBordersHeaderProps) => {
  const allDayHours = TimeUtils.getAllDayHours(account);
  const language = useLanguage();

  const getFormattedHour = (hourMoment: Moment): string => {
    if (language === 'he') {
      return hourMoment.format('HH:mm');
    }
    return hourMoment.format('h a');
  };

  return (
    <>
      {allDayHours.map((hourMoment, index) => {
        return (
          <Box key={index} sx={{ width: '100%', display: 'flex', fontSize: '12px' }}>
            <Box
              className="flex-1"
              sx={{
                color: 'text.secondary',
                marginTop: '-8px',
                textAlign: 'end',
                paddingInlineEnd: '4px',
                fontVariantNumeric: 'tabular-nums',
              }}>
              {index !== 0 && (
                <Typography component="span" display="inline-block" fontSize="12px" dir="ltr">
                  {getFormattedHour(hourMoment)}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                borderBottom: index === 23 ? 'none' : '1px solid',
                borderColor: 'mb.gridLine',
                width: '12px',
                height: '50px',
                boxSizing: 'border-box',
              }}
            />
          </Box>
        );
      })}
    </>
  );
};
